import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-form-page-shell',
  standalone: true,
  imports: [ButtonModule, ProgressSpinnerModule],
  templateUrl: './form-page-shell.component.html',
  styleUrls: ['./form-page-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormPageShellComponent {
  @Input() initialLoading: boolean | null = null;
  @Input() refreshing = false;
  @Input() blocked = false;
  @Input() error: string | boolean | null = null;
  @Input() loading = false;
  @Input() hasError = false;
  @Input() ready: boolean | null = null;
  @Input() loadingMessage = 'Ładowanie danych...';
  @Input() refreshingMessage = 'Odświeżanie danych...';
  @Input() errorTitle = 'Błąd ładowania';
  @Input() errorMessage = 'Wystąpił błąd podczas ładowania danych.';
  @Input() retryLabel = 'Spróbuj ponownie';

  @Output() retry = new EventEmitter<void>();

  onRetry(): void {
    this.retry.emit();
  }

  get resolvedReady(): boolean {
    if (this.ready !== null) {
      return this.ready;
    }

    return !this.rawInitialLoading && !this.resolvedErrorMessage;
  }

  get resolvedInitialLoading(): boolean {
    return this.rawInitialLoading && !this.resolvedReady;
  }

  get resolvedRefreshing(): boolean {
    return this.refreshing && this.resolvedReady;
  }

  get resolvedBlocked(): boolean {
    return this.blocked && this.resolvedReady;
  }

  get resolvedErrorMessage(): string | null {
    if (typeof this.error === 'string') {
      return this.error;
    }

    if (this.error === true || this.hasError) {
      return this.errorMessage;
    }

    return null;
  }

  get showErrorState(): boolean {
    return !!this.resolvedErrorMessage && !this.resolvedReady && !this.resolvedInitialLoading;
  }

  get showContentOverlay(): boolean {
    return this.resolvedRefreshing || this.resolvedBlocked;
  }

  private get rawInitialLoading(): boolean {
    return this.initialLoading ?? this.loading;
  }
}
